import { CreateIndustryDto } from '../../types/industry.types';
import { PaginationInputDto } from '../../model/common/PaginatedInputDto';
import { get, post, del } from '../../utils/BaseService';

export async function getAllIndustries(dispatch: any, props: PaginationInputDto) {
  return await post(dispatch, '/industry/getAllIndustries', props);
}

export async function getIndustryById(dispatch: any, id: string) {
  return await get(dispatch, `/industry/getIndustryById/${id}`, null);
}

export async function createIndustry(dispatch: any, props: CreateIndustryDto) {
  return await post(dispatch, '/industry/createIndustry', props);
}

export async function updateIndustry(dispatch: any, id: string, props: CreateIndustryDto) {
  return await post(dispatch, `/industry/updateIndustry/${id}`, props);
}

export async function deleteIndustry(dispatch: any, id: string) {
  return await del(dispatch, `/industry/deleteIndustry/${id}`, parseInt(id));
}